export default {
	about_the: 'Sobre as',
	about_the: 'Sobre a',
	company_agency: 'Plataforma que deseja acessar:',
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files:
		'Explore todo o nosso universo de cursos, vídeos, artigos e arquivos.',
	project_name: 'Programa Inwictus',
	welcome_to: 'Bem-vindo(a) ao',
}
